import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class ContainerTypeService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }


   getAll():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/container-type`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    create(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/container-type`,  data)
        .pipe(catchError(this.handleError));
       
    }


    delete(id: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/container-type/${id}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }



}

